import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { SpecialSituation } from '../types/SpecialSituation';

const URL = '/v2/special-situations';

class SpecialSituationsService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<SpecialSituation>> {
    return axios.get(URL, config);
  }

  static getByFilterForAdmin(config?: AxiosRequestConfig): Promise<PagedResponse<SpecialSituation>> {
    return axios.get(`${URL}?includeDisabled=true`, config);
  }

  static patch(
    id: number,
    data: SpecialSituation,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SpecialSituation>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static update(
    id: number,
    data: SpecialSituation,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SpecialSituation>> {
    return axios.put(`${URL}/${id}`, data, config);
  }

  static create(
    data: SpecialSituation,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SpecialSituation>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig) {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { SpecialSituationsService };
